import { useQuery } from 'react-query';

import { getVersion as queryFn } from 'api/endPoints/getVersion';

export const useQueryApiVersion = () => {
    return useQuery({ queryKey: ['ApiVersion'], queryFn });
};
